import { Mui } from '@osu/react-ui';
import ScholarsDashboardLink from '../../../Common/components/ScholarsDashboardLink';
import ScholarsPreferencesReadOnly from '../scholars/ScholarsPreferencesReadOnly';

/**
 * Template for "Under Review" step content
 * Receives pre-processed content as props from step building logic
 * @param {Object} props

 * @param {string} props.stepId - Step identifier ('honors-review')
 * @param {string} [props.status] - Review status ('ACTIVE' or 'COMPLETE')
 * @param {Object} props.stepContent - Pre-processed content from step building
 */
function UnderReviewTemplate({ 
  stepId = 'honors-review',
  status = 'ACTIVE',
  stepContent // Pre-processed content from step building
}) {
  // Use the pre-processed content passed as props
  const content = stepContent || {};

  return (
    <Mui.Box>
      {/* Main content description */}
      <Mui.Typography variant="body1" sx={{ mb: 2 }}>
        {content.description}
      </Mui.Typography>

      {/* Alert message if present */}
      {content.message && (
        <Mui.Alert severity="info" sx={{ mb: 3 }}>
          <Mui.Typography variant="body2">
            {content.message}
          </Mui.Typography>
        </Mui.Alert>
      )}

      {/* Read-only preferences list (shown after submission, during review) */}
      {content.showScholarsDashLink && <ScholarsPreferencesReadOnly />}

      {/* Additional info if present */}
      {content.additionalInfo && (
        <Mui.Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {content.additionalInfo}
        </Mui.Typography>
      )}

      {/* Contact information from configurable constants */}
      {content.contactInfo && (
        <Mui.Box sx={{ mt: 3, p: 2, backgroundColor: '#e3f2fd', borderRadius: 1, border: '1px solid #bbdefb' }}>
          <Mui.Typography variant="body2" color="primary">
            <strong>Questions?</strong>
          </Mui.Typography>
          <Mui.Typography variant="body2" sx={{ mt: 1 }}>
            {content.contactInfo}
          </Mui.Typography>
        </Mui.Box>
      )}

      {content.showScholarsDashLink && <ScholarsDashboardLink sx={{ mt: 3 }} />}
    </Mui.Box>
  );
}

export default UnderReviewTemplate;